export default __webpack_public_path__ + "static/media/file.814fa246.png";